import React, { useEffect } from 'react';
import { API } from './api';

// Cross-app switch landing.
//
// Exchanges a one-time switch CODE (carried in the URL fragment) for a fresh
// session in THIS app, server-side. It ATOMICALLY replaces whatever session was
// stored in this app with the code's identity. If the code is missing, invalid,
// expired, already used, or the identity lacks access to this app, it CLEARS any
// stored session and shows the login screen. It NEVER falls back to a previously
// stored session — switching as user A can only ever produce user A signed in, or
// a login screen.
//
// The exchange uses a bare fetch (NOT authFetch) so the stale session token is
// never attached — the code is the sole one-time credential.
export default function SwitchLanding() {
  useEffect(() => {
    const clearAndLogin = () => {
      try { localStorage.removeItem('token'); } catch (e) { /* ignore */ }
      try { window.history.replaceState(null, '', '/'); } catch (e) { /* ignore */ }
      window.location.replace('/');
    };

    const m = window.location.hash.match(/[#&]code=([^&]+)/);
    if (!m) { clearAndLogin(); return; }

    let code = '';
    try { code = decodeURIComponent(m[1]); } catch (e) { clearAndLogin(); return; }

    // Strip the code from the visible URL immediately (it is single-use anyway).
    try { window.history.replaceState(null, '', '/'); } catch (e) { /* ignore */ }

    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/switch/exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        });
        if (!res.ok) { clearAndLogin(); return; }
        const data = await res.json();
        if (!data || !data.token) { clearAndLogin(); return; }
        // Atomically replace this app's stored session with the handed-off identity,
        // then hard-reload so AuthContext re-fetches /me as that identity.
        try {
          localStorage.setItem('token', data.token);
        } catch (e) {
          clearAndLogin();
          return;
        }
        window.location.replace('/');
      } catch (e) {
        clearAndLogin();
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center text-[#00D4FF]">
      Signing you in…
    </div>
  );
}
